<ng-content></ng-content>
<div class="icon-wrapper" [ngStyle]="barStyle">
  <svg class="icon" [ngClass]="{'center': center}">
    <use xlink:href="/assets/img/sprite.svg?v1.7#header-underline"></use>
  </svg>
</div>